export enum BaseDataset {
  CheckSummary = 'checkSummary',
  ItemSales = 'itemSales',
  ItemDiscounts = 'itemDiscounts',
  LaborShifts = 'laborShifts',
}

// These enum values are uppercase to match the column names in our base
// datasets' column names in their final result sets. This makes it more
// convenient to use these enum values when building SQL queries for custom
// reports.
export enum CheckSummaryColumns {
  BusinessDate = 'BusinessDate',
  StoreId = 'StoreId',
  StoreName = 'StoreName',
  TransactionNumber = 'TransactionNumber',
  TableDescription = 'TableDescription',
  CompAmount = 'CompAmount',
  PromoAmount = 'PromoAmount',
  PaymentAmount = 'PaymentAmount',
  CashTenders = 'CashTenders',
  NonCashTenders = 'NonCashTenders',
  GuestCount = 'GuestCount',
  ItemCount = 'ItemCount',
  ItemSales = 'ItemSales',
  GrossSales = 'GrossSales',
  GiftCardSales = 'GiftCardSales',
  SurchargeAmount = 'SurchargeAmount',
  ExclusiveTaxes = 'ExclusiveTaxes',
  InclusiveTaxes = 'InclusiveTaxes',
  DayPart = 'DayPart',
  RevenueCenter = 'RevenueCenter',
  NetSales = 'NetSales',
  TaxExemptAmount = 'TaxExemptAmount',
  TimeZone = 'TimeZone',
  EmployeeId = 'EmployeeId',
  EmployeeName = 'EmployeeName',
  CheckOpenTime = 'CheckOpenTime',
  CheckCloseTime = 'CheckCloseTime',
  VoidAmount = 'VoidAmount',
  NonCashTips = 'NonCashTips',
  Gratuities = 'Gratuities',
}
export enum ItemSalesColumns {
  BusinessDate = 'BusinessDate',
  StoreId = 'StoreId',
  StoreName = 'StoreName',
  TransactionNumber = 'TransactionNumber',
  EmployeeId = 'EmployeeId',
  EmployeeName = 'EmployeeName',
  ProductId = 'ProductId',
  ProductName = 'ProductName',
  ItemId = 'ItemId',
  ParentItemId = 'ParentItemId',
  RevenueCenterId = 'RevenueCenterId',
  RevenueCenterName = 'RevenueCenterName',
  CategoryId = 'CategoryId',
  CategoryName = 'CategoryName',
  OrderModeId = 'OrderModeId',
  OrderModeName = 'OrderModeName',
  ItemPrice = 'ItemPrice',
  DiscountedPrice = 'DiscountedPrice',
  Quantity = 'Quantity',
  AddedDateTime = 'AddedDateTime',
  SellType = 'SellType',
  IsReturned = 'IsReturned',
  IsVoided = 'IsVoided',
  TimeZone = 'TimeZone',
}
export enum ItemDiscountsColumns {
  BusinessDate = 'BusinessDate',
  StoreId = 'StoreId',
  StoreName = 'StoreName',
  TransactionNumber = 'TransactionNumber',
  ProductId = 'ProductId',
  ProductName = 'ProductName',
  ItemId = 'ItemId',
  DiscountType = 'DiscountType',
  UniqueId = 'UniqueId',
  Id = 'Id',
  Name = 'Name',
  ItemPrice = 'ItemPrice',
  DiscountedPrice = 'DiscountedPrice',
  DiscountAmount = 'DiscountAmount',
  AddedDateTime = 'AddedDateTime',
  TimeZone = 'TimeZone',
}
export enum LaborShiftsColumns {
  BusinessDate = 'BusinessDate',
  StoreId = 'StoreId',
  StoreName = 'StoreName',
  EmployeeId = 'EmployeeId',
  EmployeeName = 'EmployeeName',
  ShiftId = 'ShiftId',
  JobId = 'JobId',
  JobName = 'JobName',
  ClockInDatetime = 'ClockInDatetime',
  ClockOutDatetime = 'ClockOutDatetime',
  TotalShiftTime = 'TotalShiftTime',
  TotalPaidBreakTime = 'TotalPaidBreakTime',
  TotalUnpaidBreakTime = 'TotalUnpaidBreakTime',
  TotalWages = 'TotalWages',
  DeclaredTips = 'DeclaredTips',
  EmployeeSales = 'EmployeeSales',
  Edited = 'Edited',
  LastEditedDateTime = 'LastEditedDateTime',
  LastEditedById = 'LastEditedById',
  LastEditedByName = 'LastEditedByName',
  TimeZone = 'TimeZone',
}
